<template> 
  <div 
    ref="element"
    class="Choice" 
    :class="{ 'enable': used != null }" 
    @click="onClick()">

    <img 
      class="Choice__close" 
      :class="{ 'enable': used != null }" 
      :src="require('../img/assets/close.png')"/>
    
    <div class="Choice__txt" :class="{ 'selected': this.isSelected() }">{{ txt }}</div>

  </div>
</template>
<script>

import { Oeuvre_words } from '../js/Words.js'

export default {
  name: 'Choice',
  props: ['id'],
  data: () => ({
    words: null,
    txt: '',
    used: null,
  }),
  translations: {
    fr: {
      drop: 'Déposer ici'
    },
    en: {
      drop: 'Drop here'
    }
  },
  watch: {
    drag_end(nw, od) {
      if(nw.choice == this.id) {
        this.$store.commit('app/SET_AMBIANCE', 'selection')
        TweenMax.from(this.$refs.element, .7 ,{ scale: .5, ease: Cubic.easeOut })
        this.used = nw.id
      }
    },
    drag_back(nw, od) {
      if(nw.choice == this.id)
        this.used = null
    },
    used(nw, od) {
      this.txt = (nw) ? this.words[this.used] : this.useDefault()
    },
    lang(nw, od) {
      this.words = Oeuvre_words[nw][this.oeuvre.name]
      this.txt = (this.used) ? this.words[this.used] : this.useDefault()
    },

  },
  computed: {
    drag_end() { return this.$store.getters['app/drag_end'] },
    drag_back() { return this.$store.getters['app/drag_back'] }, 
    current_drag() { return this.$store.getters['app/current_drag'] }
  },
  created() {
    this.txt = this.useDefault()
    this.words = Oeuvre_words[this.lang][this.oeuvre.name]
  },
  mounted(){
    TweenMax.set(this.$refs.element, { y: '+=30' })
    TweenMax.to(this.$refs.element, .7 ,{ opacity: 1, y: 0, ease: Cubic.easeOut, delay: _.random(1, 1.75) })
  },
  methods: {
    onClick() {
      this.$store.commit('app/SET_AMBIANCE', 'delete')
      this.$store.commit('app/DRAG_BACK', { choice: this.id, id: this.used })
    },
    useDefault() {
      return this.trans('drop')
    },
    isSelected() {
      if(this.current_drag)
        if(this.current_drag.zone == this.id && !this.used) 
          return true 
      else 
        return false
    },
  }, 
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'


.Choice
  position relative
  height 36px
  border-radius 18px
  display flex
  justify-content center
  align-items center
  background rgba(black, .75)
  pointer-events none
  cursor pointer
  font-size 16px
  margin 0 4px
  padding 0 24px
  color #868787
  opacity 0
  font-weight 300

  +max-screen-height(tablet-portrait)
    height 32px
    font-size 13px
    padding 0 16px

  &.enable 
    pointer-events initial
    color black
    background linear-gradient(35deg, rgba(blue, 1) 30%, rgba(green, 1) 70%, rgba(yellow, 1) 100%)
    padding 0 24px

  &__txt
    &.selected
      color yellow

  &__close 
    position absolute
    opacity 0
    width 20px
    top -10px
    right 12px

    &.enable 
      opacity 1

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Choice.vue